import { render, staticRenderFns } from "./DialogAssignPlataforma.vue?vue&type=template&id=6a23dad0&scoped=true"
import script from "./DialogAssignPlataforma.vue?vue&type=script&lang=js"
export * from "./DialogAssignPlataforma.vue?vue&type=script&lang=js"
import style0 from "./DialogAssignPlataforma.vue?vue&type=style&index=0&id=6a23dad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a23dad0",
  null
  
)

export default component.exports